'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { authApi, API_BASE_URL } from '@/lib/api';

export default function AddMemberPage() {
  const router = useRouter();

  useEffect(() => {
    const checkAuthAndRedirect = async () => {
      try {
        // Check user session (same pattern as dashboard pages)
        const userResponse = await fetch(`${API_BASE_URL}/api/auth/check/?session_type=user`, {
          method: 'GET',
          credentials: 'include', // Sends auth_token cookie
        });
        
        if (userResponse.ok) {
          const userData = await userResponse.json();
          
          if (userData.authenticated) {
            // User is logged in → redirect to create leader profile page
            router.replace('/create-leader-profile');
          } else {
            // User is not logged in → redirect to signup page
            router.replace('/signup-page');
          }
        } else {
          // Not authenticated
          router.replace('/signup-page');
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
        // If session check fails, assume not logged in
        router.replace('/signup-page');
      }
    };

    checkAuthAndRedirect();
  }, [router]);

  // Show loading state while checking auth
  return (
    <div data-component-id="src/app/add-member/page.tsx:45:4" data-component-path="src/app/add-member/page.tsx" data-component-line="45" data-component-end-line="50" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20items-center%20justify-center%20min-h-screen%22%7D" className="flex items-center justify-center min-h-screen">
      <div data-component-id="src/app/add-member/page.tsx:46:6" data-component-path="src/app/add-member/page.tsx" data-component-line="46" data-component-end-line="49" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%22%7D" className="text-center">
        <div data-component-id="src/app/add-member/page.tsx:47:8" data-component-path="src/app/add-member/page.tsx" data-component-line="47" data-component-end-line="47" data-component-file="page.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22animate-spin%20rounded-full%20h-12%20w-12%20border-b-2%20border-green-700%20mx-auto%22%7D" className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-700 mx-auto"></div>
        <p data-component-id="src/app/add-member/page.tsx:48:8" data-component-path="src/app/add-member/page.tsx" data-component-line="48" data-component-end-line="48" data-component-file="page.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22mt-4%20text-gray-600%22%2C%22textContent%22%3A%22Redirecting...%22%7D" className="mt-4 text-gray-600">Redirecting...</p>
      </div>
    </div>
  );
}

